import { usePostType } from "@/lib/helpers/template"
import Block from "@/components/wrappers/block"
import Blocks from "@/components/Blocks"
import BlockHeader from "@/common/partials/block-header/block-header"
import styles from "./links.module.css"
import classNames from "classnames"

export default function Links({ block }) {
  const postType = usePostType()
  const gap = block?.attrs?.blockGap || "normal"
  const onPlate = postType === "member-page"
  const settings = {
    "theme/link": { variant: "arrow-block" }
  }

  return (
    <Block
      block={block}
      gap={gap}
      innerWrapper={onPlate}
      className={classNames(styles.wrapper, {
        "on-plate": onPlate
      })}>
      <BlockHeader
        icon={block?.attrs?.icon}
        heading={block?.attrs?.heading}
        text={block?.attrs?.text}
        align={block?.attrs?.align}
      />
      <div className="link-grid">
        <Blocks blocks={block.innerBlocks} settings={settings} />
      </div>
    </Block>
  )
}
